import request from 'superagent';

const Api = {

  get(url, options = {}) {
    return new ApiRequest('get', url, options).send();
  },

  post(url, data, options = {}) {
    options.data = data;
    return new ApiRequest('post', url, options).send();
  },

  patch(url, data, options = {}) {
    options.data = data;
    return new ApiRequest('patch', url, options).send();
  },

  put(url, data, options = {}) {
    options.data = data;
    return new ApiRequest('put', url, options).send();
  },

  delete(url, options = {}) {
    return new ApiRequest('delete', url, options).send();
  },

  request(method, url, data, options = {}) {
    options.data = data;
    return new ApiRequest(method, url, options).send();
  }

};

class ApiRequest {

  constructor(method, url, options) {
    this.method   = method.toLowerCase();
    this.url      = url;
    this.options  = options;
  }

  send() {
    let req = request(this.method.toUpperCase(), this.url)
      .accept('json')
      .type('json');

    if (typeof this.options.params == 'object') {
      const params = this.options.params;

      /* that http library doesn't know about arrays in query parameters... */
      Object.keys(params).forEach(k => {
        if (Array.isArray(params[k])) {
          params[`${k}[]`] = params[k];
          delete params[k];
        }
      });

      req = req.query(params);
    }

    if (this.options.data instanceof File) {
      req = req.set("Content-Type", "application/octet-stream");
      req = req.send(this.options.data);
    }
    else if (typeof this.options.data == 'object') {
      const settings = {};
      if (window._token) settings.authenticity_token = _token;

      const data = Object.assign({}, this.options.data, settings);

      req = req.send(data);
    }

    return req;
  }

}

export default Api;
